import { TableOfContents, IconWrapper, Number, List, LeftContent, RightContent } from './TableOfContents';
import ListItem from './ListItem';
import Text from './Text';
import Title from './Title';
import useTableOfContents from './useTableOfContents';
TableOfContents.displayName = "TableOfContentsBase";
List.displayName = "TableOfContents.List";
ListItem.displayName = "TableOfContents.ListItem";
LeftContent.displayName = "TableOfContents.LeftContent";
RightContent.displayName = "TableOfContents.RightContent";
Title.displayName = "TableOfContents.Title";
IconWrapper.displayName = "TableOfContents.IconWrapper";
Text.displayName = "TableOfContents.Text";
Number.displayName = "TableOfContents.Number";
export { TableOfContents as default, ListItem, LeftContent, RightContent, List, Text, IconWrapper, Title, Number, useTableOfContents };